import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker, matchPath, useLocation } from 'react-router-dom';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx } from "react/jsx-runtime";
function UnsavedChangesBlockerModal(_ref) {
  var hasUnsavedChanges = _ref.hasUnsavedChanges,
    _ref$permissablePaths = _ref.permissablePaths,
    permissablePaths = _ref$permissablePaths === void 0 ? [] : _ref$permissablePaths,
    _ref$includeQueryPara = _ref.includeQueryParams,
    includeQueryParams = _ref$includeQueryPara === void 0 ? false : _ref$includeQueryPara;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  // `location.pathname` ensures that changes of query parameters
  // on the same page are allowed and don't trigger a prompt
  var paths = includeQueryParams ? _toConsumableArray(permissablePaths) : [].concat(_toConsumableArray(permissablePaths), [location.pathname]);

  // Keep the latest check in a ref so we never pass a new function reference
  // to useBlocker on every render. An unstable function causes React Router to
  // call updateState() each render, which re-renders all router consumers and
  // creates an infinite loop in React 19.
  var blockerCheckRef = useRef(function () {
    return false;
  });
  blockerCheckRef.current = function (_ref2) {
    var nextLocation = _ref2.nextLocation;
    return hasUnsavedChanges && !paths.some(function (path) {
      return matchPath(path, nextLocation.pathname);
    });
  };
  var stableBlockerFn = useCallback(function (args) {
    return blockerCheckRef.current(args);
  }, []);
  var blocker = useBlocker(stableBlockerFn);
  useEffect(function () {
    if (blocker.state === 'blocked') {
      setIsModalOpen(true);
    }
  }, [blocker.state]);
  if (!isModalOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_unsaved_changes_title'),
    body: t('modal_confirm_quit_edit_without_save'),
    onClose: function onClose() {
      var _blocker$reset;
      setIsModalOpen(false);
      (_blocker$reset = blocker.reset) === null || _blocker$reset === void 0 || _blocker$reset.call(blocker);
    },
    buttons: [{
      label: t('actions_cancel'),
      onClick: function onClick() {
        var _blocker$reset2;
        setIsModalOpen(false);
        (_blocker$reset2 = blocker.reset) === null || _blocker$reset2 === void 0 || _blocker$reset2.call(blocker);
      }
    }, {
      label: t('actions_confirm'),
      variant: 'primary',
      onClick: function onClick() {
        var _blocker$proceed;
        setIsModalOpen(false);
        (_blocker$proceed = blocker.proceed) === null || _blocker$proceed === void 0 || _blocker$proceed.call(blocker);
      }
    }]
  });
}
export default UnsavedChangesBlockerModal;